var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowCore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.078,
    height: 19.13,
    viewBox: "0 0 34.078 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.807,
    cy: 0.62,
    r: 1.312,
    gradientTransform: "matrix(-0.995, -0.104, -0.06, 0.576, 1.648, 0.347)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee0979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6a00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9095.914,2238.458v-26.464l-5.025,5.2a1.728,1.728,0,1,1-2.486-2.4l7.927-8.211a1.731,1.731,0,0,1,2.447-.042.094.094,0,0,0,.018.015c.823.567,7.77,8.283,7.77,8.283a1.76,1.76,0,0,1-.042,2.464,1.7,1.7,0,0,1-2.429-.042l-4.826-5.067v26.265a1.676,1.676,0,0,1-3.353,0Z",
    transform: "translate(2240.133 -9087.916) rotate(90)",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowCore);
export default __webpack_public_path__ + "static/media/ic_arrow-core.e55a173be6064835fc596f0c19b5a128.svg";
export { ForwardRef as ReactComponent };